import API from "../interceptor/axios.interceptor.service";

class SuppliersBackendApiService {
    static async getSupplierDetail(id) {
        const url = `/api/v1/suppliers/${id}`;
        try {
            const response = await API.get(url);
            return response.data;
        } catch (e) {
            const message = e && e.response && e.response.data ? e.response.data.message : e.message;
            return {
                success: false,
                message: message || 'Something went wrong while fetching supplier detail, please try again!',
            }
        }
    }

    static async createNewSupplier(payload) {
        const url = `/api/v1/suppliers/`;
        try {
            const response = await API.post(url, payload);
            return response.data;
        } catch (e) {
            const message = e && e.response && e.response.data ? e.response.data.message : e.message;
            return {
                success: false,
                message: message || 'Something went wrong creating a new supplier!',
            }
        }
    }

    static async getSuppliersList(payload) {
        const url = payload.pageNo && payload.pageLimit ?  `/api/v1/suppliers/?pageNo=${payload.pageNo}&pageLimit=${payload.pageLimit}` : `/api/v1/suppliers/`;
        try {
            const response = await API.get(url);
            return response.data;
        } catch (e) {
            const message = e && e.response && e.response.data ? e.response.data.message : e.message;
            return {
                success: false,
                message: message || 'Something went wrong while fetching the supplier list!',
            }
        }
    }

    static async updateSupplierDetails(payload) {
        const url = `/api/v1/suppliers/${payload.id}`;
        try {
            const response = await API.put(url, payload);
            return response.data;
        } catch (e) {
            const message = e && e.response && e.response.data ? e.response.data.message : e.message;
            return {
                success: false,
                message: message || 'Something went wrong while logging you out!',
            }
        }
    }
}

export default SuppliersBackendApiService;